<template>
  <div class="brd-root" :style="themePageStyle">
    <head>
      <meta charset="utf-8" /><title>FLOCKR | Buy Request</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <link rel="shortcut icon" href="/assets/images/favicon.svg">
      <link href="/assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/icons.min.css" rel="stylesheet" type="text/css" />
      <link href="/assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <link href="/assets/css/custom.css" rel="stylesheet" type="text/css" />
    </head>
    <div :data-sidebar="darkMode ? 'dark' : 'light'">
    <div id="layout-wrapper">
      <nav class="brd-topbar">
        <div class="container d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center" style="gap:16px;">
            <a href="javascript:void(0)" @click="$router.push('/')"><img src="/assets/images/flockr_logo.png" alt="Flockr" style="height:34px;" /></a>
            <button class="btn btn-sm btn-link text-muted p-0" @click="$router.push('/marketplace/buy-requests')"><i class="mdi mdi-arrow-left me-1"></i>Buy Requests</button>
          </div>
        </div>
      </nav>

      <div v-if="loading" class="text-center py-5" style="padding-top:100px!important;"><div class="spinner-border text-warning"></div></div>

      <div v-else-if="!request.id" class="text-center py-5" style="padding-top:100px!important;">
        <i class="mdi mdi-file-alert-outline" style="font-size:64px;color:var(--fm-s,#3A3530);"></i>
        <h5 class="mt-3" style="color:var(--fm-h,#F5F0E8);">Buy Request Not Found</h5>
        <button class="btn btn-warning mt-2" @click="$router.push('/marketplace/buy-requests')">Browse Buy Requests</button>
      </div>

      <div v-else class="container brd-container">
        <div class="row">
          <!-- Main Content -->
          <div class="col-lg-8">
            <div class="brd-card mb-3">
              <div class="d-flex align-items-center gap-3 mb-3">
                <div class="brd-avatar">{{ getInitials(request.buyer_name) }}</div>
                <div>
                  <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);">{{ request.buyer_name }}</div>
                  <div v-if="request.buyer_rating" style="color:#f1b44c;font-size:12px;"><i class="mdi mdi-star"></i> {{ Number(request.buyer_rating).toFixed(1) }}</div>
                </div>
                <span class="ms-auto badge bg-success bg-opacity-15 text-success">{{ request.status }}</span>
              </div>

              <h5 class="fw-bold" style="color:var(--fm-h,#F5F0E8);">{{ request.title }}</h5>
              <p v-if="request.description" style="color:var(--fm-m,#A09888);font-size:14px;">{{ request.description }}</p>

              <div class="brd-details">
                <div class="brd-detail"><span class="brd-dl">Species</span><span class="brd-dv">{{ request.species_name }}</span></div>
                <div class="brd-detail" v-if="request.breed_name"><span class="brd-dl">Breed</span><span class="brd-dv">{{ request.breed_name }}</span></div>
                <div class="brd-detail"><span class="brd-dl">Quantity</span><span class="brd-dv">{{ request.quantity_needed }}</span></div>
                <div class="brd-detail" v-if="request.sex_preference && request.sex_preference !== 'any'"><span class="brd-dl">Sex</span><span class="brd-dv">{{ request.sex_preference }}</span></div>
                <div class="brd-detail" v-if="request.min_weight_kg || request.max_weight_kg"><span class="brd-dl">Weight Range</span><span class="brd-dv">{{ request.min_weight_kg || '—' }} – {{ request.max_weight_kg || '—' }} kg</span></div>
                <div class="brd-detail" v-if="request.budget_min || request.budget_max"><span class="brd-dl">Budget</span><span class="brd-dv" style="color:#BFA164;font-weight:700;">{{ (request.currency || 'KES') }} {{ formatPrice(request.budget_min) }} – {{ formatPrice(request.budget_max) }} ({{ request.price_type }})</span></div>
                <div class="brd-detail" v-if="request.delivery_location"><span class="brd-dl">Delivery</span><span class="brd-dv">{{ request.delivery_location }}</span></div>
                <div class="brd-detail" v-if="request.needed_by"><span class="brd-dl">Needed By</span><span class="brd-dv" style="color:#f1b44c;">{{ formatDate(request.needed_by) }}</span></div>
                <div class="brd-detail"><span class="brd-dl">Posted</span><span class="brd-dv">{{ formatDate(request.created_at) }}</span></div>
              </div>
            </div>

            <!-- Suggested farmers (owner only) -->
            <div v-if="isOwner && (loadingSuggestions || suggestedFarmers.length)" class="brd-card mb-3">
              <h6 class="fw-bold mb-1" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-account-search me-2" style="color:#BFA164;"></i>Suggested Farmers</h6>
              <p style="color:var(--fm-s,#6B6356);font-size:12px;margin-bottom:12px;">Farmers whose herds match this request. Start a chat to negotiate directly.</p>
              <div v-if="loadingSuggestions" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
              <div v-else>
                <div v-for="(f,fi) in suggestedFarmers" :key="'sf-'+fi" class="brd-resp">
                  <div class="d-flex align-items-center gap-3">
                    <div class="brd-avatar-sm">{{ getInitials(f.display_name) }}</div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">
                        {{ f.display_name }}
                        <i v-if="f.is_verified==1" class="mdi mdi-check-decagram ms-1" style="color:#4FC3F7;font-size:13px;" title="Verified identity"></i>
                      </div>
                      <div style="color:var(--fm-m,#A09888);font-size:11px;">
                        <span style="color:#BFA164;font-weight:700;">{{ f.herd_count }}</span> {{ request.species_name }} in herd
                        <span v-if="f.county_names"> · {{ f.county_names }}</span>
                      </div>
                      <div style="color:var(--fm-s,#6B6356);font-size:11px;margin-top:2px;">{{ f.match_reason }}</div>
                      <div class="d-flex gap-1 mt-1 flex-wrap">
                        <span v-if="f.has_listing==1" class="badge bg-success bg-opacity-15 text-success" style="font-size:9px;">Selling now</span>
                        <span v-if="f.already_responded" class="badge bg-warning bg-opacity-15 text-warning" style="font-size:9px;">Responded</span>
                        <span v-else-if="f.already_notified" class="badge bg-secondary bg-opacity-15 text-muted" style="font-size:9px;">Notified</span>
                      </div>
                    </div>
                    <button class="btn btn-sm brd-btn-msg" @click="messageFarmer(f)">
                      <i class="mdi mdi-message-text me-1"></i>Chat
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- DEAL PANEL (locked + participant) -->
            <div v-if="isLocked && isParticipant && deal" class="brd-card" style="border:1px solid #BFA164;">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <h6 class="fw-bold m-0" style="color:#BFA164;"><i class="mdi mdi-handshake me-2"></i>Deal in progress</h6>
                <span class="badge bg-warning bg-opacity-15 text-warning" style="font-size:10px;text-transform:capitalize;">{{ (deal.deal_stage||'negotiating').replace(/_/g,' ') }}</span>
              </div>
              <div style="color:var(--fm-s,#6B6356);font-size:12px;margin-bottom:8px;">{{ isSeller ? 'You are the engaged seller.' : 'Locked with ' + (deal.seller_name||'the seller') + '.' }} Rate <strong style="color:#BFA164;">{{ (deal.currency || 'KES') }} {{ formatPrice(deal.offered_price) }}</strong>/{{ deal.price_type==='per_kg'?'kg':'unit' }}.</div>

              <!-- 1. LPO -->
              <div style="border-top:1px solid var(--fm-br,#1E1E1E);padding:10px 0;">
                <div style="font-weight:600;font-size:12px;color:var(--fm-h,#F5F0E8);margin-bottom:6px;"><i class="mdi" :class="deal.lpo_url?'mdi-check-circle':'mdi-numeric-1-circle-outline'" style="color:#BFA164;"></i> Purchase order (LPO)</div>
                <div v-if="deal.lpo_url"><a :href="pu(deal.lpo_url)" target="_blank" style="color:#BFA164;font-size:12px;"><i class="mdi mdi-file-document me-1"></i>View LPO</a></div>
                <div v-else-if="isOwner" class="d-flex gap-2 align-items-center">
                  <label class="btn btn-sm btn-outline-warning" style="margin:0;cursor:pointer;"><i class="mdi mdi-upload me-1"></i>{{ lpoFile?lpoFile.name:'Choose LPO' }}<input type="file" accept="image/*,video/mp4,video/quicktime,video/webm,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display:none;" @change="onLpoFile" /></label>
                  <button class="btn btn-sm btn-warning" @click="uploadLpo" :disabled="!lpoFile||dealBusy">Upload</button>
                </div>
                <div v-else style="color:var(--fm-s,#6B6356);font-size:12px;">Waiting for the buyer to upload their LPO.</div>
              </div>

              <!-- 2. Fulfilment -->
              <div style="border-top:1px solid var(--fm-br,#1E1E1E);padding:10px 0;">
                <div style="font-weight:600;font-size:12px;color:var(--fm-h,#F5F0E8);margin-bottom:6px;"><i class="mdi" :class="deal.fulfilment_method?'mdi-check-circle':'mdi-numeric-2-circle-outline'" style="color:#BFA164;"></i> Fulfilment</div>
                <div v-if="deal.fulfilment_method" style="font-size:12px;color:var(--fm-m,#A09888);text-transform:capitalize;">{{ deal.fulfilment_method.replace(/_/g,' ') }}</div>
                <div v-else class="d-flex gap-2">
                  <button class="btn btn-sm btn-outline-warning" @click="setFulfilment('seller_delivers')" :disabled="dealBusy">Seller delivers</button>
                  <button class="btn btn-sm btn-outline-warning" @click="setFulfilment('buyer_collects')" :disabled="dealBusy">Buyer collects</button>
                </div>
              </div>

              <!-- 3. Weigh & confirm -->
              <div style="border-top:1px solid var(--fm-br,#1E1E1E);padding:10px 0;">
                <div style="font-weight:600;font-size:12px;color:var(--fm-h,#F5F0E8);margin-bottom:6px;"><i class="mdi" :class="deal.final_weight_kg?'mdi-check-circle':'mdi-numeric-3-circle-outline'" style="color:#BFA164;"></i> Weigh &amp; confirm</div>
                <div style="font-size:12px;color:var(--fm-m,#A09888);line-height:1.6;">
                  Seller (dispatch): {{ deal.seller_weight_kg?deal.seller_weight_kg+'kg':'—' }} <span v-if="deal.seller_weight_confirmed==1" style="color:#50C878;">✓</span><span v-if="deal.seller_weight_proof"> · <a :href="pu(deal.seller_weight_proof)" target="_blank" style="color:#BFA164;">ticket</a></span><br/>
                  Buyer (received): {{ deal.buyer_weight_kg?deal.buyer_weight_kg+'kg':'—' }} <span v-if="deal.buyer_weight_confirmed==1" style="color:#50C878;">✓</span><span v-if="deal.buyer_weight_proof"> · <a :href="pu(deal.buyer_weight_proof)" target="_blank" style="color:#BFA164;">ticket</a></span>
                </div>
                <div v-if="deal.final_weight_kg" style="color:#50C878;font-weight:700;font-size:13px;margin-top:4px;">Agreed billable: {{ deal.final_weight_kg }}kg</div>
                <div v-if="!deal.final_weight_kg" class="mt-2">
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <input v-model="weightInput" type="number" step="0.1" class="form-control brd-input" :placeholder="(isSeller?'Dispatch':'Received')+' kg'" style="max-width:140px;" />
                    <label class="btn btn-sm btn-outline-warning" style="margin:0;cursor:pointer;"><i class="mdi mdi-camera me-1"></i>{{ weightFile?'✓':'Ticket' }}<input type="file" accept="image/*" style="display:none;" @change="onWeightFile" /></label>
                    <button class="btn btn-sm btn-warning" @click="submitWeight" :disabled="dealBusy">Submit weight</button>
                  </div>
                  <button v-if="deal.seller_weight_kg && deal.buyer_weight_kg && !((isSeller?deal.seller_weight_confirmed:deal.buyer_weight_confirmed)==1)" class="btn btn-sm btn-success mt-2" @click="confirmWeight" :disabled="dealBusy"><i class="mdi mdi-check me-1"></i>Confirm {{ deal.buyer_weight_kg }}kg billable</button>
                </div>
              </div>

              <!-- 4. Invoice & payment -->
              <div style="border-top:1px solid var(--fm-br,#1E1E1E);padding:10px 0;">
                <div style="font-weight:600;font-size:12px;color:var(--fm-h,#F5F0E8);margin-bottom:6px;"><i class="mdi" :class="(invoice&&invoice.status==='paid')?'mdi-check-circle':'mdi-numeric-4-circle-outline'" style="color:#BFA164;"></i> Invoice &amp; payment</div>
                <div v-if="deal.final_weight_kg && !invoice && isSeller" class="d-flex gap-2 align-items-center flex-wrap">
                  <select v-model="invoiceTerms" class="form-select brd-input" style="max-width:160px;"><option value="immediate">Due immediately</option><option value="net_7">Net 7 days</option><option value="net_14">Net 14 days</option><option value="net_30">Net 30 days</option><option value="cheque">Cheque</option></select>
                  <button class="btn btn-sm btn-warning" @click="generateInvoice" :disabled="dealBusy">Generate invoice</button>
                </div>
                <div v-else-if="deal.final_weight_kg && !invoice" style="color:var(--fm-s,#6B6356);font-size:12px;">Waiting for the seller to issue the invoice.</div>
                <div v-if="invoice" style="background:var(--fm-bg2,#0F0F0F);border-radius:8px;padding:10px;margin-top:6px;">
                  <div style="font-size:11px;color:var(--fm-m,#A09888);">{{ invoice.invoice_number }} · {{ (invoice.payment_terms||'').replace(/_/g,' ') }}<span v-if="invoice.due_date"> · due {{ formatDate(invoice.due_date) }}</span></div>
                  <div style="color:#BFA164;font-weight:700;font-size:18px;">{{ (invoice.currency || 'KES') }} {{ formatPrice(invoice.amount) }} <span class="badge ms-1" :class="invoice.status==='paid'?'bg-success bg-opacity-15 text-success':invoice.status==='overdue'?'bg-danger bg-opacity-15 text-danger':'bg-warning bg-opacity-15 text-warning'" style="font-size:9px;text-transform:uppercase;">{{ invoice.status }}</span></div>
                  <div v-if="invoice.status!=='paid'" class="mt-2">
                    <div v-if="isOwner" class="d-flex gap-2 align-items-center mb-2 flex-wrap">
                      <input v-model="payPhone" class="form-control brd-input" placeholder="M-Pesa 2547…" style="max-width:160px;" />
                      <button class="btn btn-sm btn-warning" @click="payInvoiceMpesa" :disabled="dealBusy"><i class="mdi mdi-cellphone me-1"></i>Pay via M-Pesa</button>
                    </div>
                    <button class="btn btn-sm btn-outline-warning" @click="recordPayment" :disabled="dealBusy"><i class="mdi mdi-receipt me-1"></i>Record payment (cheque/bank)</button>
                  </div>
                  <div v-else style="color:#50C878;font-size:12px;margin-top:4px;"><i class="mdi mdi-check-decagram me-1"></i>Paid via {{ invoice.payment_method }}<span v-if="invoice.payment_ref"> · {{ invoice.payment_ref }}</span></div>
                </div>
              </div>

              <button class="btn btn-sm btn-outline-danger w-100 mt-1" @click="releaseLock" :disabled="dealBusy"><i class="mdi mdi-lock-open-variant me-1"></i>Release request (deal off)</button>
            </div>

            <!-- Taken note for non-participants -->
            <div v-if="isLocked && !isParticipant" class="brd-card" style="text-align:center;">
              <i class="mdi mdi-handshake" style="font-size:32px;color:#BFA164;"></i>
              <div style="color:var(--fm-h,#F5F0E8);font-weight:700;margin-top:6px;">Taken — in private negotiation</div>
              <div style="color:var(--fm-s,#6B6356);font-size:12px;">This request is locked with a seller. It'll reopen if they don't reach a deal.</div>
            </div>

            <!-- Responses -->
            <div v-if="!isLocked || isOwner" class="brd-card">
              <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-comment-multiple-outline me-2"></i>Responses ({{ responses.length }})</h6>
              <div v-if="loadingResponses" class="text-center py-3"><div class="spinner-border spinner-border-sm text-warning"></div></div>
              <div v-else-if="responses.length === 0" class="text-center py-3"><p style="color:var(--fm-s,#6B6356);font-size:13px;">No responses yet. Be the first to respond!</p></div>
              <div v-else>
                <div v-for="(resp,ri) in responses" :key="'r-'+ri" class="brd-resp">
                  <div class="d-flex align-items-center gap-3">
                    <div class="brd-avatar-sm">{{ getInitials(resp.seller_name) }}</div>
                    <div class="flex-fill">
                      <div class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:13px;">{{ resp.seller_name }} <span v-if="resp.seller_rating" style="color:#f1b44c;font-size:11px;"><i class="mdi mdi-star"></i>{{ Number(resp.seller_rating).toFixed(1) }}</span></div>
                      <div style="color:#BFA164;font-weight:700;">{{ (resp.currency || 'KES') }} {{ formatPrice(resp.offered_price) }} <span style="color:var(--fm-s,#6B6356);font-weight:400;font-size:11px;">({{ resp.price_type }}) × {{ resp.offered_quantity }}</span></div>
                      <div class="d-flex align-items-center gap-2 mt-1">
                        <span style="color:#50C878;font-weight:700;font-size:13px;">Total: KES {{ formatPrice(respTotal(resp)) }}</span>
                      </div>
                      <div v-if="resp.avg_weight_kg" style="color:var(--fm-m,#A09888);font-size:11px;">Avg weight: {{ resp.avg_weight_kg }}kg</div>
                      <div v-if="resp.message" class="mt-1" style="color:var(--fm-m,#A09888);font-size:12px;background:var(--fm-bg2,#0F0F0F);padding:8px 10px;border-radius:6px;border-left:2px solid #2A2520;">{{ resp.message }}</div>
                      <div v-if="parsePhotos(resp.photos).length" class="brd-att">
                        <template v-for="(ph,pi) in parsePhotos(resp.photos)" :key="'rp-'+pi">
                          <a v-if="fileKind(ph)==='image'" :href="pu(ph)" target="_blank" class="brd-att-img"><img :src="pu(ph)" /></a>
                          <video v-else-if="fileKind(ph)==='video'" :src="pu(ph)" class="brd-att-img" controls preload="metadata"></video>
                          <a v-else :href="pu(ph)" target="_blank" class="brd-att-doc"><i class="mdi" :class="docIcon(ph)"></i><span>{{ fileName(ph) }}</span></a>
                        </template>
                      </div>
                    </div>
                    <span class="badge" :class="resp.status==='pending'?'bg-warning bg-opacity-15 text-warning':resp.status==='accepted'?'bg-success bg-opacity-15 text-success':resp.status==='rejected'?'bg-danger bg-opacity-15 text-danger':'bg-secondary bg-opacity-15 text-muted'" style="font-size:10px;">{{ resp.status }}</span>
                  </div>

                  <!-- BUYER ACTIONS (only for request owner) -->
                  <div v-if="isOwner && resp.status==='pending'" class="brd-resp-actions">
                    <button class="btn btn-sm brd-btn-accept" @click="acceptResponse(resp)" :disabled="processing">
                      <i class="mdi mdi-check-circle me-1"></i>Accept & Order
                    </button>
                    <button class="btn btn-sm brd-btn-msg" @click="messageResponse(resp)">
                      <i class="mdi mdi-message-text me-1"></i>Message
                    </button>
                    <button class="btn btn-sm brd-btn-reject" @click="rejectResponse(resp)" :disabled="processing">
                      <i class="mdi mdi-close-circle me-1"></i>Decline
                    </button>
                  </div>

                  <!-- ACCEPTED: show checkout button -->
                  <div v-if="isOwner && resp.status==='accepted'" class="brd-resp-actions">
                    <button class="btn btn-sm btn-warning fw-bold" @click="goToCheckout(resp)">
                      <i class="mdi mdi-cart-arrow-right me-1"></i>Proceed to Checkout
                    </button>
                    <button class="btn btn-sm brd-btn-msg" @click="messageResponse(resp)">
                      <i class="mdi mdi-message-text me-1"></i>Message Seller
                    </button>
                  </div>

                  <!-- Seller: view their response status -->
                  <div v-if="!isOwner && resp.seller_id===myUserId && resp.status==='accepted'" class="brd-resp-accepted-note">
                    <i class="mdi mdi-check-decagram me-1" style="color:#50C878;"></i>Your response was accepted! The buyer will proceed to checkout.
                  </div>

                  <!-- Seller: edit / withdraw their own pending response (or edit their accepted response) -->
                  <div v-if="!isOwner && resp.seller_id===myUserId && (resp.status==='pending' || resp.status==='accepted') && editingRespId !== resp.id" class="brd-resp-actions" style="margin-top:8px;">
                    <button class="btn btn-sm btn-outline-warning" @click="beginEditResp(resp)">
                      <i class="mdi mdi-pencil-outline me-1"></i>{{ resp.status==='accepted' ? 'Update my offer' : 'Edit my offer' }}
                    </button>
                    <button v-if="resp.status==='pending'" class="btn btn-sm btn-outline-danger" @click="withdrawResp(resp)" :disabled="processing">
                      <i class="mdi mdi-close-circle-outline me-1"></i>Withdraw
                    </button>
                  </div>

                  <!-- Seller: inline edit form -->
                  <div v-if="editingRespId === resp.id" style="background:rgba(191,161,100,.06);border:1px solid rgba(191,161,100,.25);border-radius:10px;padding:12px;margin-top:8px;">
                    <div style="color:#BFA164;font-weight:600;font-size:12px;text-transform:uppercase;letter-spacing:.5px;margin-bottom:8px;">
                      <i class="mdi mdi-pencil-outline me-1"></i>Edit your response
                    </div>
                    <div class="row g-2">
                      <div class="col-6"><label class="brd-label">Price (KES)</label><input v-model="editForm.offeredPrice" type="number" step="0.01" class="form-control brd-input" /></div>
                      <div class="col-6"><label class="brd-label">Quantity</label><input v-model="editForm.offeredQuantity" type="number" min="1" class="form-control brd-input" /></div>
                      <div class="col-6"><label class="brd-label">Avg weight (kg)</label><input v-model="editForm.avgWeightKg" type="number" step="0.1" class="form-control brd-input" placeholder="Optional" /></div>
                      <div class="col-6"><label class="brd-label">Price type</label>
                        <select v-model="editForm.priceType" class="form-select brd-input">
                          <option value="per_unit">Per unit</option>
                          <option value="per_kg">Per kg</option>
                          <option value="lot">Whole lot</option>
                        </select>
                      </div>
                      <div class="col-12"><label class="brd-label">Message</label><textarea v-model="editForm.message" class="form-control brd-input" rows="2"></textarea></div>
                    </div>
                    <div class="d-flex gap-2 mt-2">
                      <button class="btn btn-sm btn-outline-secondary flex-fill" @click="cancelEditResp" :disabled="savingEditResp">Cancel</button>
                      <button class="btn btn-sm btn-warning flex-fill" @click="saveEditResp(resp)" :disabled="savingEditResp || !editForm.offeredPrice || !editForm.offeredQuantity">
                        <span v-if="savingEditResp"><span class="spinner-border spinner-border-sm me-1"></span>Saving…</span>
                        <span v-else><i class="mdi mdi-check me-1"></i>Save changes</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Sidebar: Respond Form -->
          <div class="col-lg-4 mt-3 mt-lg-0">
            <div class="brd-card" v-if="!isOwner">
              <h6 class="fw-bold mb-3" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-reply me-2"></i>Respond to Request</h6>
              <div class="mb-2">
                <label class="brd-label">Offered Price (KES) <span class="text-danger">*</span></label>
                <input v-model="respForm.offeredPrice" type="number" class="form-control brd-input" placeholder="0.00" />
              </div>
              <div class="mb-2">
                <label class="brd-label">Quantity Available <span class="text-danger">*</span></label>
                <input v-model="respForm.offeredQuantity" type="number" class="form-control brd-input" min="1" placeholder="e.g. 50" />
              </div>
              <div class="mb-2">
                <label class="brd-label">Avg Weight (kg)</label>
                <input v-model="respForm.avgWeightKg" type="number" step="0.1" class="form-control brd-input" placeholder="Optional" />
              </div>
              <div class="mb-2">
                <label class="brd-label">Price Type</label>
                <select v-model="respForm.priceType" class="form-select brd-input">
                  <option value="per_unit">Per Unit</option>
                  <option value="per_kg">Per Kg</option>
                </select>
              </div>
              <div class="mb-3">
                <label class="brd-label">Message</label>
                <textarea v-model="respForm.message" class="form-control brd-input" rows="3" placeholder="Describe your stock..."></textarea>
              </div>
              <div class="mb-3">
                <label class="brd-label">Photos, video, files &amp; contracts <span style="color:var(--fm-s,#6B6356);font-weight:400;">(show the buyer your stock)</span></label>
                <div class="d-flex flex-wrap gap-2 mb-2" v-if="respFiles.length">
                  <div v-for="(f,fi) in respFiles" :key="'rf-'+fi" style="position:relative;width:60px;height:60px;border-radius:8px;overflow:hidden;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg2,#0F0F0F);display:flex;align-items:center;justify-content:center;">
                    <img v-if="respPreviews[fi]" :src="respPreviews[fi]" style="width:100%;height:100%;object-fit:cover;" />
                    <i v-else class="mdi mdi-file-document-outline" style="font-size:22px;color:var(--fm-s,#6B6356);"></i>
                    <button type="button" @click="removeRespFile(fi)" style="position:absolute;top:1px;right:1px;background:rgba(0,0,0,.6);color:#FF6B6B;border:none;border-radius:50%;width:18px;height:18px;font-size:11px;line-height:1;">×</button>
                  </div>
                </div>
                <label class="btn btn-sm btn-outline-warning" style="cursor:pointer;margin:0;"><i class="mdi mdi-paperclip me-1"></i>Attach<input type="file" accept="image/*,video/mp4,video/quicktime,video/webm,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" multiple style="display:none;" @change="onRespFiles" /></label>
              </div>
              <div v-if="respError" class="mb-2" style="color:#FF6B6B;font-size:12px;">{{ respError }}</div>
              <button class="btn btn-warning w-100" @click="submitResponse" :disabled="!respForm.offeredPrice || !respForm.offeredQuantity || respSubmitting">
                <span v-if="respSubmitting"><span class="spinner-border spinner-border-sm me-1"></span></span>
                <span v-else><i class="mdi mdi-send me-1"></i> Submit Response</span>
              </button>
            </div>

            <div class="brd-card" v-if="isOwner">
              <h6 class="fw-bold mb-2" style="color:var(--fm-h,#F5F0E8);"><i class="mdi mdi-clipboard-text me-2" style="color:#BFA164;"></i>Your Buy Request</h6>
              <div class="brd-owner-stats">
                <div class="brd-owner-stat"><span>Responses</span><strong style="color:#BFA164;">{{ responses.length }}</strong></div>
                <div class="brd-owner-stat"><span>Accepted</span><strong style="color:#50C878;">{{ responses.filter(function(r){return r.status==='accepted'}).length }}</strong></div>
                <div class="brd-owner-stat"><span>Best Price</span><strong style="color:#50C878;">{{ responses.length ? 'KES '+formatPrice(Math.min.apply(null,responses.map(function(r){return Number(r.offered_price)}))) : '—' }}</strong></div>
              </div>
              <p style="color:var(--fm-s,#6B6356);font-size:12px;margin-top:12px;">Click <strong style="color:#50C878;">Accept & Order</strong> on a response to start the purchase, or <strong style="color:#BFA164;">Message</strong> to negotiate.</p>
              <div class="d-flex flex-column gap-2 mt-3">
                <button class="btn btn-sm btn-outline-warning w-100" @click="$router.push('/marketplace/buy-requests/create')"><i class="mdi mdi-plus me-1"></i>New Buy Request</button>
                <button v-if="request.status==='active'" class="btn btn-sm btn-outline-danger w-100" @click="closeRequest" :disabled="processing"><i class="mdi mdi-close-circle me-1"></i>Close Request</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<style>

/* === GLOBAL THEME === */
html[data-theme="light"] body { background:#FFFFFF!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-card,html[data-theme="light"] .p2c,html[data-theme="light"] .ld-section,html[data-theme="light"] .ld-action-card,html[data-theme="light"] .ld-seller-card,html[data-theme="light"] .ld-info-card,html[data-theme="light"] .ld-related-card { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-overlay .fm-modal,html[data-theme="light"] .ad-overlay .ad-modal { background:#FFFFFF!important; border-color:#E8E2DA!important; }
html[data-theme="light"] .fm-input,html[data-theme="light"] .fm-select { background:#F7F5F2!important; border-color:#E0D8D0!important; color:#1A1A1A!important; }
html[data-theme="light"] .fm-label { color:#555!important; }
html[data-theme="dark"] body { background:#0A0A0A!important; color:#F5F0E8!important; }
</style>
<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .card-body{color:#1A1A1A!important}
html[data-theme="light"] .modal-content{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
html[data-theme="light"] .form-control,html[data-theme="light"] .form-select{background:#FFFFFF!important;border-color:#E0D8D0!important;color:#1A1A1A!important}
html[data-theme="light"] .table{color:#1A1A1A!important}
html[data-theme="light"] .table th{color:#555!important;border-color:#E8E2DA!important}
html[data-theme="light"] .table td{border-color:#F0EBE4!important}
html[data-theme="light"] [style*="color:#F5F0E8"]{color:#1A1A1A!important}
html[data-theme="light"] [style*="color:#6B6356"]{color:#777!important}
html[data-theme="light"] [style*="color:#A09888"]{color:#555!important}
html[data-theme="light"] [style*="background:#0F0F0F"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#141414"]{background:#FFFFFF!important}
html[data-theme="light"] [style*="background:#1E1E1E"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="background:#0A0A0A"]{background:#F7F5F2!important}
html[data-theme="light"] [style*="background:#1a1510"]{background:#FFF8F0!important}
html[data-theme="light"] [style*="background:#1A1A1A"]{background:#F0EBE4!important}
html[data-theme="light"] [style*="border:1px solid #1E1E1E"]{border-color:#E8E2DA!important}
html[data-theme="light"] [style*="border:1px solid #2A2520"]{border-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1A1A1A"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #1E1E1E"]{border-bottom-color:#F0EBE4!important}
html[data-theme="light"] [style*="border-bottom:1px solid #2A2520"]{border-bottom-color:#E0D8D0!important}
html[data-theme="light"] [style*="border-top:1px solid #2A2520"]{border-top-color:#E0D8D0!important}
html[data-theme="light"] [style*="color:#BFA164"]{color:#BFA164!important}
html[data-theme="light"] [style*="color:#50C878"]{color:#50C878!important}
html[data-theme="light"] [style*="color:#4FC3F7"]{color:#4FC3F7!important}
html[data-theme="light"] [style*="color:#FF6B6B"]{color:#FF6B6B!important}
html[data-theme="light"] [style*="color:#FF9800"]{color:#FF9800!important}
html[data-theme="light"] [style*="color:#CE93D8"]{color:#CE93D8!important}
</style>

<style>
:root{
  --fm-h:#F5F0E8;
  --fm-s:#6B6356;
  --fm-m:#A09888;
  --fm-bg1:#141414;
  --fm-bg2:#0F0F0F;
  --fm-bg3:#1E1E1E;
  --fm-br:#1E1E1E;
  --fm-page:#0A0A0A;
}
html[data-theme="light"]{
  --fm-h:#1A1A1A;
  --fm-s:#777777;
  --fm-m:#555555;
  --fm-bg1:#FFFFFF;
  --fm-bg2:#F7F5F2;
  --fm-bg3:#F0EBE4;
  --fm-br:#E8E2DA;
  --fm-page:#F7F5F2;
}
html[data-theme="light"] body,
html[data-theme="light"] #layout-wrapper,
html[data-theme="light"] .brd-root,
html[data-theme="light"] .brd-container{background:var(--fm-page)!important;color:var(--fm-h)!important;}
html[data-theme="dark"] body,
html[data-theme="dark"] #layout-wrapper,
html[data-theme="dark"] .brd-root,
html[data-theme="dark"] .brd-container{background:var(--fm-page)!important;color:var(--fm-h)!important;}
html[data-theme="light"] .brd-topbar{background:#FFFFFF!important;border-bottom-color:#E8E2DA!important;}
html[data-theme="dark"] .brd-topbar{background:var(--fm-bg1,#141414)!important;}
html[data-theme="light"] .brd-card,
html[data-theme="light"] .brd-sidebar-card,
html[data-theme="light"] .brd-response-card{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important;}
html[data-theme="light"] .brd-title,
html[data-theme="light"] .brd-section-title,
html[data-theme="light"] .brd-price,
html[data-theme="light"] .brd-budget,
html[data-theme="light"] .brd-dv{color:#1A1A1A!important;}
html[data-theme="light"] .brd-meta,
html[data-theme="light"] .brd-label,
html[data-theme="light"] .brd-dl,
html[data-theme="light"] .brd-empty{color:#555!important;}
html[data-theme="light"] .brd-input,
html[data-theme="light"] textarea,
html[data-theme="light"] input,
html[data-theme="light"] select{background:#FFFFFF!important;color:#1A1A1A!important;border-color:#E0D8D0!important;}
html[data-theme="light"] .brd-input::placeholder,
html[data-theme="light"] textarea::placeholder,
html[data-theme="light"] input::placeholder{color:#777!important;}
</style>

<style scoped>
.brd-root{background:var(--fm-page,#0A0A0A)!important;min-height:100vh;color:var(--fm-h,#F5F0E8)!important}
.brd-topbar{position:sticky;top:0;z-index:100;padding:12px 0;background:var(--fm-bg1,#141414)!important;backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.brd-container{padding-top:80px;padding-bottom:60px;max-width:1000px}
.brd-card,.brd-sidebar-card,.brd-response-card{background:var(--fm-bg1,#141414)!important;border:1px solid var(--fm-br,#1E1E1E);border-radius:10px;padding:20px}
.brd-avatar{width:44px;height:44px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:700;color:#BFA164;flex-shrink:0}
.brd-avatar-sm{width:34px;height:34px;border-radius:50%;background:var(--fm-bg3,#1E1E1E);display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#BFA164;flex-shrink:0}
.brd-details{margin-top:16px}
.brd-detail{display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--fm-br,#1A1A1A);font-size:13px}
.brd-detail:last-child{border-bottom:none}
.brd-dl{color:var(--fm-s,#6B6356)}
.brd-dv{color:#D4C9B8}
.brd-resp{padding:14px 0;border-bottom:1px solid var(--fm-br,#1A1A1A)}
.brd-resp:last-child{border-bottom:none}
.brd-label{font-size:12px;font-weight:600;color:#D4C9B8;margin-bottom:4px;display:block}
.brd-att{display:flex;flex-wrap:wrap;gap:8px;margin-top:8px}
.brd-att-img{width:84px;height:84px;border-radius:10px;overflow:hidden;border:1px solid var(--fm-br,#2A2520);background:var(--fm-bg2,#0F0F0F);object-fit:cover;display:block;cursor:pointer}
.brd-att-img img{width:100%;height:100%;object-fit:cover;display:block}
.brd-att-doc{display:inline-flex;align-items:center;gap:6px;max-width:200px;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#2A2520);border-radius:8px;padding:8px 10px;color:#BFA164;text-decoration:none;font-size:12px}
.brd-att-doc i{font-size:20px;flex-shrink:0}
.brd-att-doc span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}
.brd-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#2A2520);color:var(--fm-h,#F5F0E8);border-radius:8px;font-size:13px}
.brd-input:focus{border-color:#BFA164;box-shadow:0 0 0 2px rgba(191,161,100,.15);background:var(--fm-bg2,#0F0F0F);color:var(--fm-h,#F5F0E8)}
.brd-input option{background:var(--fm-bg1,#141414)!important;color:var(--fm-h,#F5F0E8)}
.brd-resp-actions{display:flex;gap:8px;margin-top:10px;padding-top:10px;border-top:1px solid var(--fm-br,#1A1A1A)}
.brd-btn-accept{background:rgba(80,200,120,0.12);border:1px solid rgba(80,200,120,0.25);color:#50C878;font-size:12px;font-weight:600;border-radius:8px}
.brd-btn-accept:hover{background:rgba(80,200,120,0.2);color:#50C878}
.brd-btn-reject{background:rgba(255,107,107,0.08);border:1px solid rgba(255,107,107,0.2);color:#FF6B6B;font-size:12px;font-weight:600;border-radius:8px}
.brd-btn-reject:hover{background:rgba(255,107,107,0.15);color:#FF6B6B}
.brd-btn-msg{background:rgba(191,161,100,0.1);border:1px solid rgba(191,161,100,0.2);color:#BFA164;font-size:12px;font-weight:600;border-radius:8px}
.brd-btn-msg:hover{background:rgba(191,161,100,0.2);color:#BFA164}
.brd-resp-accepted-note{margin-top:8px;padding:8px 12px;background:rgba(80,200,120,0.06);border:1px solid rgba(80,200,120,0.15);border-radius:8px;font-size:12px;color:#50C878}
.brd-owner-stats{display:flex;gap:12px;margin-top:12px}
.brd-owner-stat{flex:1;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E);border-radius:8px;padding:10px;text-align:center}
.brd-owner-stat span{display:block;font-size:10px;color:var(--fm-s,#6B6356);text-transform:uppercase}
.brd-owner-stat strong{display:block;font-size:16px;margin-top:2px}

/* ===== MOBILE — feels-like-an-app ===== */
@media (max-width: 768px) {
  .brd-container { padding-top: 70px !important; padding-bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important; padding-left: 12px !important; padding-right: 12px !important; }
  .brd-card { padding: 14px !important; border-radius: 10px !important; }
  .brd-avatar { width: 36px; height: 36px; font-size: 13px; }
  .brd-btn, .brd-btn-msg { padding: 8px 12px; font-size: 13px; }
  .brd-owner-stats { gap: 8px; }
  .brd-owner-stat { padding: 8px; }
  .brd-owner-stat strong { font-size: 14px; }
  .brd-att { padding: 8px; }
}
</style>
<script>
/* eslint-disable */
import {  execute, executeJson, flocker, uploads  } from "@/api";

function applyBuyReqTheme(vm) {
  const t = document.documentElement.getAttribute('data-theme') || localStorage.getItem('flockr_theme') || (vm && vm.darkMode ? 'dark' : 'light');
  const isDark = t !== 'light';
  if (vm) vm.darkMode = isDark;
  window.__flockrSetTheme(isDark ? 'dark' : 'light');

  if (document.body) {
    document.body.setAttribute('data-sidebar', isDark ? 'dark' : 'light');
    document.body.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    document.body.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }

  const wrapper = document.getElementById('layout-wrapper');
  if (wrapper) {
    wrapper.style.background = isDark ? '#0A0A0A' : '#F7F5F2';
    wrapper.style.color = isDark ? '#F5F0E8' : '#1A1A1A';
  }
}

export default {
  name: "BuyRequestDetail",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null,
    loading:true,loadingResponses:true,respSubmitting:false,respError:'',processing:false,request:{},responses:[],respForm:{offeredPrice:'',offeredQuantity:'',avgWeightKg:'',priceType:'per_unit',message:''},respFiles:[],respPreviews:[],
    editingRespId:null, editForm:{offeredPrice:'',offeredQuantity:'',avgWeightKg:'',priceType:'per_unit',message:''}, savingEditResp:false,
    dealBusy:false, weightInput:'', weightFile:null, invoice:null, invoiceTerms:'immediate', payPhone:'', lpoFile:null,
    suggestedFarmers:[], loadingSuggestions:false}},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    themeCardStyle(){return this.darkMode?'background:#141414!important;border:1px solid #1E1E1E!important;':'background:#FFFFFF!important;border:1px solid #E8E2DA!important;'},
    themeInputStyle(){return this.darkMode?'background:#0F0F0F;border:1px solid #2A2520;color:#F5F0E8;':'background:#FFFFFF;border:1px solid #E0D8D0;color:#1A1A1A;'},

    isOwner(){return this.request.buyer_id===sessionStorage.getItem('userId')},
    myUserId(){return sessionStorage.getItem('userId')||''},
    isLocked(){return (this.request.lock_status||'open')==='locked'},
    isSeller(){return this.isLocked && this.request.locked_seller_id===this.myUserId},
    isParticipant(){return this.isOwner || this.isSeller},
    deal(){ if(!this.isLocked)return null; return (this.responses||[]).find(function(r){return r.status!=='withdrawn'&&r.status!=='rejected'}) || null; }
  },
  mounted(){
    applyBuyReqTheme(this);
    this.themeObserver = new MutationObserver(() => applyBuyReqTheme(this));
    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });
    var id=this.$route.params.id;if(id)this.load(id)},
  beforeUnmount(){
    if(this.themeObserver)this.themeObserver.disconnect()
  },
  methods:{
    async load(id){
      this.loading=true;
      try{var r=await executeJson({function:"getBuyRequests",keyword:''},flocker);if(r.data.success){var found=(r.data.data.buyRequests||[]).find(function(b){return b.id===id});if(found)this.request=found}}catch(e){console.error(e)}
      this.loading=false;this.fetchResponses(id);
      if(this.isOwner)this.fetchSuggestions(id)
    },
    async fetchSuggestions(id){
      this.loadingSuggestions=true;
      try{var r=await executeJson({function:'getBuyRequestFarmerSuggestions',buyRequestId:id,buyerId:this.myUserId,limit:10},flocker);if(r.data&&r.data.success)this.suggestedFarmers=r.data.data.farmers||[]}catch(e){console.error(e)}
      this.loadingSuggestions=false
    },
    async messageFarmer(f){
      try{
        var r=await executeJson({function:'getOrCreateConversation',userA:this.myUserId,userB:f.user_id,contextType:'buy_request',contextId:this.request.id},flocker);
        if(r.data&&r.data.success&&r.data.data&&r.data.data.conversationId){
          this.$router.push({path:'/messages/'+r.data.data.conversationId,query:{name:f.display_name,ref:'buyrequest',refId:this.request.id}});
          return;
        }
      }catch(e){console.error(e)}
      this.$router.push('/messages');
    },
    async fetchResponses(id){
      this.loadingResponses=true;
      try{var r=await executeJson({function:"getBuyRequestResponses",buyRequestId:id,viewerId:this.myUserId},flocker);if(r.data.success)this.responses=r.data.data.responses||[]}catch(e){console.error(e)}
      this.loadingResponses=false;
      if(this.isLocked && this.deal && ['invoiced','paid','completed'].indexOf(this.deal.deal_stage)>-1) this.loadInvoice();
    },
    pu(u){if(!u)return'';if(String(u).indexOf('http')===0)return u;return uploads+String(u).replace(/^uploads\//,'');},
    parsePhotos(p){ if(!p)return[]; if(Array.isArray(p))return p; try{var a=JSON.parse(p);return Array.isArray(a)?a:[]}catch(e){return[]} },
    fileKind(u){ var n=String((u&&u.url)||u||'').toLowerCase().split('?')[0]; if(/\.(jpe?g|png|webp|gif|bmp)$/.test(n))return'image'; if(/\.(mp4|mov|webm|m4v|3gp)$/.test(n))return'video'; return'doc'; },
    fileName(u){ var s=String((u&&(u.name||u.url))||u||''); return s.split('/').pop().split('?')[0] || 'File'; },
    docIcon(u){ var n=String((u&&u.url)||u||'').toLowerCase(); if(n.indexOf('.pdf')>-1)return'mdi-file-pdf-box'; if(/\.docx?/.test(n))return'mdi-file-word-box'; if(/\.xlsx?/.test(n)||n.indexOf('.csv')>-1)return'mdi-file-excel-box'; if(/\.pptx?/.test(n))return'mdi-file-powerpoint-box'; return'mdi-file-document-outline'; },
    onRespFiles(e){
      // Compress any image files before adding — upstream proxy caps multipart POSTs at ~1 MB,
      // so 5+ raw phone photos would blow past that and axios reports "Something went wrong".
      var self=this;
      var raw=Array.from(e.target.files||[]);
      var remaining=Math.max(0, 6-this.respFiles.length);
      raw=raw.slice(0, remaining);
      var pending=raw.length;
      if(pending===0) return;
      raw.forEach(function(f){
        if(f.type.indexOf('image')!==0){
          self.respFiles.push(f);
          self.respPreviews.push('');
          if(--pending===0){/* done */}
          return;
        }
        self.compressRespImage(f, function(compressed){
          self.respFiles.push(compressed||f);
          self.respPreviews.push(URL.createObjectURL(compressed||f));
          if(--pending===0){/* done */}
        });
      });
    },
    compressRespImage(file, callback){
      // Same aggressive strategy as CreateListingPage — target ~260 KB per photo.
      var TARGET_BYTES=260*1024, MIN_DIM=640, MIN_QUALITY=0.35;
      var reader=new FileReader();
      reader.onload=function(e){
        var img=new Image();
        img.onload=function(){
          var fit=function(dim,q,done){
            var w=img.width,h=img.height;
            if(w>dim||h>dim){ if(w>h){h=Math.round(h*dim/w);w=dim;} else {w=Math.round(w*dim/h);h=dim;} }
            var canvas=document.createElement('canvas');
            canvas.width=w;canvas.height=h;
            canvas.getContext('2d').drawImage(img,0,0,w,h);
            canvas.toBlob(function(blob){
              if(!blob){done(null);return;}
              if(blob.size<=TARGET_BYTES){done(blob);return;}
              if(q>MIN_QUALITY) fit(dim,Math.max(MIN_QUALITY,q-0.15),done);
              else if(dim>MIN_DIM) fit(Math.max(MIN_DIM,Math.round(dim*0.85)),MIN_QUALITY,done);
              else done(blob);
            },'image/jpeg',q);
          };
          fit(1000,0.7,function(blob){
            if(!blob){callback(null);return;}
            callback(new File([blob], file.name.replace(/\.[^.]+$/, '.jpg'), {type:'image/jpeg'}));
          });
        };
        img.src=e.target.result;
      };
      reader.readAsDataURL(file);
    },
    removeRespFile(i){this.respFiles.splice(i,1);this.respPreviews.splice(i,1);},
    async submitResponse(){
      this.respSubmitting=true;this.respError='';
      try{
        var r;
        if(this.respFiles.length){
          var fd=new FormData();
          fd.append('function','respondToBuyRequest');fd.append('buyRequestId',this.request.id);fd.append('sellerId',this.myUserId);
          fd.append('offeredQuantity',this.respForm.offeredQuantity);fd.append('offeredPrice',this.respForm.offeredPrice);
          fd.append('priceType',this.respForm.priceType);fd.append('message',this.respForm.message||'');
          if(this.respForm.avgWeightKg)fd.append('avgWeightKg',this.respForm.avgWeightKg);
          this.respFiles.forEach(function(f,i){fd.append('photo'+i,f);});
          r=await execute(fd,flocker);
        } else {
          var p={function:"respondToBuyRequest",buyRequestId:this.request.id,sellerId:this.myUserId,offeredQuantity:this.respForm.offeredQuantity,offeredPrice:this.respForm.offeredPrice,priceType:this.respForm.priceType,message:this.respForm.message};
          if(this.respForm.avgWeightKg)p.avgWeightKg=this.respForm.avgWeightKg;
          r=await executeJson(p,flocker);
        }
        if(r.data.success){this.respForm={offeredPrice:'',offeredQuantity:'',avgWeightKg:'',priceType:'per_unit',message:''};this.respFiles=[];this.respPreviews=[];this.load(this.request.id)}
        else{this.respError=r.data.message||'Failed to submit.'}
      }catch(e){
        var status=(e&&e.response&&e.response.status)||0;
        if(status===413) this.respError='Photos too large. Please attach fewer photos or smaller ones and try again.';
        else if(status>=500) this.respError='Server error ('+status+'). Please try again in a moment.';
        else if(!navigator.onLine) this.respError='You appear to be offline. Reconnect and try again.';
        else this.respError='Upload failed'+(status?' ('+status+')':'')+'. Please try again.';
      }
      this.respSubmitting=false
    },
    // ===== Meat-deal lifecycle =====
    async loadInvoice(){
      try{var r=await executeJson({function:'getMeatInvoice',responseId:this.deal.id},flocker);if(r.data.success)this.invoice=r.data.data.invoice||null}catch(e){}
    },
    async releaseLock(){
      if(!confirm('Release this request back to the open market? The current negotiation ends.'))return;
      this.dealBusy=true;
      try{var r=await executeJson({function:'releaseBuyRequestLock',buyRequestId:this.request.id,userId:this.myUserId},flocker);if(r.data.success){this.load(this.request.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    onLpoFile(e){this.lpoFile=e.target.files&&e.target.files[0];},
    async uploadLpo(){
      if(!this.lpoFile){alert('Choose your LPO file first');return}
      this.dealBusy=true;
      try{var fd=new FormData();fd.append('function','uploadDealLPO');fd.append('responseId',this.deal.id);fd.append('buyerId',this.myUserId);fd.append('lpo',this.lpoFile);
        var r=await execute(fd,flocker);if(r.data.success){this.lpoFile=null;this.fetchResponses(this.request.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    async setFulfilment(method){
      this.dealBusy=true;
      try{var r=await executeJson({function:'setDealFulfilment',responseId:this.deal.id,userId:this.myUserId,method:method},flocker);if(r.data.success)this.fetchResponses(this.request.id);else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    onWeightFile(e){this.weightFile=e.target.files&&e.target.files[0];},
    async submitWeight(){
      if(!this.weightInput||Number(this.weightInput)<=0){alert('Enter a valid weight');return}
      this.dealBusy=true;
      try{var fd=new FormData();fd.append('function','submitDealWeight');fd.append('responseId',this.deal.id);fd.append('userId',this.myUserId);fd.append('role',this.isSeller?'seller':'buyer');fd.append('weightKg',this.weightInput);
        if(this.weightFile)fd.append('proof',this.weightFile);
        var r=await execute(fd,flocker);if(r.data.success){this.weightInput='';this.weightFile=null;this.fetchResponses(this.request.id)}else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    async confirmWeight(){
      this.dealBusy=true;
      try{var r=await executeJson({function:'confirmDealWeight',responseId:this.deal.id,userId:this.myUserId,role:this.isSeller?'seller':'buyer'},flocker);if(r.data.success)this.fetchResponses(this.request.id);else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    async generateInvoice(){
      this.dealBusy=true;
      try{var r=await executeJson({function:'generateMeatInvoice',responseId:this.deal.id,sellerId:this.myUserId,paymentTerms:this.invoiceTerms},flocker);if(r.data.success){await this.fetchResponses(this.request.id);await this.loadInvoice()}else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    async payInvoiceMpesa(){
      if(!this.payPhone){alert('Enter your M-Pesa phone');return}
      this.dealBusy=true;
      try{var r=await executeJson({function:'payMeatInvoice',invoiceId:this.invoice.id,payerId:this.myUserId,phone:this.payPhone},flocker);if(r.data.success){alert('Check your phone and enter your M-Pesa PIN. The invoice updates once payment confirms.')}else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    async recordPayment(){
      var method=prompt('Payment method (cheque / bank / cash / mpesa):','cheque');if(!method)return;
      var ref=prompt('Reference (cheque no. / txn ref):','')||'';
      this.dealBusy=true;
      try{var r=await executeJson({function:'recordInvoicePayment',invoiceId:this.invoice.id,userId:this.myUserId,paymentMethod:method,paymentRef:ref},flocker);if(r.data.success){await this.fetchResponses(this.request.id);await this.loadInvoice()}else alert(r.data.message||'Failed')}catch(e){alert('Error')}
      this.dealBusy=false;
    },
    respTotal(resp) {
      var price = Number(resp.offered_price) || 0;
      var qty = Number(resp.offered_quantity) || 1;
      return price * qty;
    },
    beginEditResp(resp){
      this.editingRespId = resp.id;
      this.editForm = {
        offeredPrice: resp.offered_price || '',
        offeredQuantity: resp.offered_quantity || '',
        avgWeightKg: resp.avg_weight_kg || '',
        priceType: resp.price_type || 'per_unit',
        message: resp.message || ''
      };
    },
    cancelEditResp(){ if (this.savingEditResp) return; this.editingRespId = null; },
    async saveEditResp(resp){
      this.savingEditResp = true;
      try {
        var p = {
          function: 'updateBuyRequestResponse',
          responseId: resp.id,
          sellerId: sessionStorage.getItem('userId'),
          offeredPrice: this.editForm.offeredPrice,
          offeredQuantity: this.editForm.offeredQuantity,
          priceType: this.editForm.priceType,
          message: this.editForm.message || ''
        };
        if (this.editForm.avgWeightKg !== '' && this.editForm.avgWeightKg !== null) p.avgWeightKg = this.editForm.avgWeightKg;
        var r = await executeJson(p, flocker);
        if (r.data && r.data.success) {
          this.editingRespId = null;
          await this.fetchResponses(this.request.id);
        } else {
          alert((r.data && r.data.message) || 'Could not save changes');
        }
      } catch(e) { alert('Network error — try again'); }
      this.savingEditResp = false;
    },
    async withdrawResp(resp){
      if (!confirm('Withdraw your offer on this buy request? You can submit a new one anytime while the request is still open.')) return;
      this.processing = true;
      try {
        var r = await executeJson({
          function: 'withdrawBuyRequestResponse',
          responseId: resp.id,
          sellerId: sessionStorage.getItem('userId')
        }, flocker);
        if (r.data && r.data.success) {
          await this.fetchResponses(this.request.id);
        } else {
          alert((r.data && r.data.message) || 'Could not withdraw');
        }
      } catch(e) { alert('Network error — try again'); }
      this.processing = false;
    },
    async acceptResponse(resp) {
      if (!confirm('Accept this offer from ' + resp.seller_name + ' for KES ' + this.formatPrice(this.respTotal(resp)) + '?\n\nYou can then proceed to checkout.')) return;
      this.processing = true;
      try {
        var r = await executeJson({ function:'manageBuyRequestResponse', responseId: resp.id, action:'accept', buyRequestId: this.request.id }, flocker);
        if (r.data.success) { this.fetchResponses(this.request.id); }
        else { alert(r.data.message || 'Failed'); }
      } catch(e) { alert('Network error'); }
      this.processing = false;
    },
    async rejectResponse(resp) {
      if (!confirm('Decline response from ' + resp.seller_name + '?')) return;
      this.processing = true;
      try {
        var r = await executeJson({ function:'manageBuyRequestResponse', responseId: resp.id, action:'reject', buyRequestId: this.request.id }, flocker);
        if (r.data.success) { this.fetchResponses(this.request.id); }
        else { alert(r.data.message || 'Failed'); }
      } catch(e) { alert('Network error'); }
      this.processing = false;
    },
    async messageResponse(resp) {
      var myUserId = sessionStorage.getItem('userId');
      try {
        var r = await executeJson({
          function: 'getOrCreateConversation',
          userA: myUserId,
          userB: resp.seller_id,
          contextType: 'buy_request',
          contextId: this.request.id
        }, flocker);
        if (r.data && r.data.success && r.data.data && r.data.data.conversationId) {
          this.$router.push({ path: '/messages/' + r.data.data.conversationId, query: { name: resp.seller_name, ref: 'buyrequest', refId: this.request.id } });
          return;
        }
      } catch (e) { console.error(e); }
      this.$router.push('/messages');
    },
    goToCheckout(resp) {
      // Buy-request checkout uses `type=buy_request` and passes the full response context
      // in the query. CheckoutPage detects the type and skips the listing_offer lookup that
      // would otherwise match the wrong offer (both tables use auto-inc bigint IDs).
      this.$router.push({
        path: '/checkout/' + resp.id,
        query: {
          type: 'buy_request',
          buyRequestId: this.request.id,
          sellerId: resp.seller_id,
          sellerName: resp.seller_name,
          price: resp.offered_price,
          quantity: resp.offered_quantity,
          priceType: resp.price_type,
          avgWeightKg: resp.avg_weight_kg || '',
          listingId: resp.listing_id || '',
          animalId: resp.animal_id || '',
          batchId: resp.batch_id || '',
          species: this.request.species_name,
          title: this.request.title
        }
      });
    },
    async closeRequest() {
      if (!confirm('Close this buy request? It will no longer accept responses.')) return;
      this.processing = true;
      try {
        var r = await executeJson({ function:'updateBuyRequestStatus', requestId: this.request.id, status:'cancelled' }, flocker);
        if (r.data.success) { this.request.status = 'cancelled'; }
        else { alert(r.data.message || 'Failed'); }
      } catch(e) { alert('Network error'); }
      this.processing = false;
    },
    formatPrice(a){return a?Number(a).toLocaleString('en-KE'):'0'},
    formatDate(d){if(!d)return'';return new Date(d).toLocaleDateString('en-KE',{day:'numeric',month:'short',year:'numeric'})},
    getInitials(n){if(!n)return'?';return n.split(' ').map(function(w){return w[0]}).join('').substring(0,2).toUpperCase()}
  }
};
</script>
